export default __webpack_public_path__ + "static/media/loader.2d27ead7.svg";